// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/legacy_portal_service.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { LegacyPortalEventServiceAddEventGoodsToWatchlistRequest, LegacyPortalEventServiceAddEventGoodsToWatchlistResponse, LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest, LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse, LegacyPortalEventServiceGetWatchlistEventGoodsRequest, LegacyPortalEventServiceGetWatchlistEventGoodsResponse, LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest, LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse } from "./legacy_portal_service_pb";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";
/**
 * @generated from service spwn.event.v1.LegacyPortalEventService
 */
export const LegacyPortalEventService = {
    typeName: "spwn.event.v1.LegacyPortalEventService",
    methods: {
        /**
         * イベントグッズをウォッチリストに追加
         *
         * @generated from rpc spwn.event.v1.LegacyPortalEventService.AddEventGoodsToWatchlist
         */
        addEventGoodsToWatchlist: {
            name: "AddEventGoodsToWatchlist",
            I: LegacyPortalEventServiceAddEventGoodsToWatchlistRequest,
            O: LegacyPortalEventServiceAddEventGoodsToWatchlistResponse,
            kind: MethodKind.Unary,
        },
        /**
         * イベントグッズをウォッチリストから削除
         *
         * @generated from rpc spwn.event.v1.LegacyPortalEventService.RemoveEventGoodsFromWatchlist
         */
        removeEventGoodsFromWatchlist: {
            name: "RemoveEventGoodsFromWatchlist",
            I: LegacyPortalEventServiceRemoveEventGoodsFromWatchlistRequest,
            O: LegacyPortalEventServiceRemoveEventGoodsFromWatchlistResponse,
            kind: MethodKind.Unary,
        },
        /**
         * ユーザのウォッチリストを取得
         *
         * @generated from rpc spwn.event.v1.LegacyPortalEventService.GetWatchlistEventGoods
         */
        getWatchlistEventGoods: {
            name: "GetWatchlistEventGoods",
            I: LegacyPortalEventServiceGetWatchlistEventGoodsRequest,
            O: LegacyPortalEventServiceGetWatchlistEventGoodsResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
        /**
         * idを指定してイベントグッズを取得
         *
         * @generated from rpc spwn.event.v1.LegacyPortalEventService.GetAllEventGoodsByEventGoodsFirestoreIds
         */
        getAllEventGoodsByEventGoodsFirestoreIds: {
            name: "GetAllEventGoodsByEventGoodsFirestoreIds",
            I: LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsRequest,
            O: LegacyPortalEventServiceGetAllEventGoodsByEventGoodsFirestoreIdsResponse,
            kind: MethodKind.Unary,
            idempotency: MethodIdempotency.NoSideEffects,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map